import i18n from '../../locales/index'
import { genBasicStore } from '@/store/vuex'
export default genBasicStore('function_payment')
